import { APICore } from "./apiCore";
import {
  IFiltroRankingFeedback,
  IRankingForneceramResponse,
  IRankingReceberamResponse,
  IResumoTotalFeedbackResponse,
} from "types/entities/RankingFeedbackTypes";

const api = new APICore();

const DASHBOARD_URL = "/solicitacao-feedback-dashboard";

/** Por colaborador destinatário. tipo_id = 0 significa todos os tipos. */
const getMaisReceberamFeedback = (filtro: IFiltroRankingFeedback) =>
  api.get<IRankingReceberamResponse>(`${DASHBOARD_URL}/mais-receberam`, filtro);

/** Por usuário autor. tipo_id = 0 significa todos os tipos. */
const getMaisForneceramFeedback = (filtro: IFiltroRankingFeedback) =>
  api.get<IRankingForneceramResponse>(`${DASHBOARD_URL}/mais-forneceram`, filtro);

/**
 * O tipo filtra só as contagens de feedbacks; pedidos não têm tipo e seguem
 * apenas o período. Sem período, considera todo o histórico.
 */
const getResumoTotalFeedback = (filtro: IFiltroRankingFeedback) =>
  api.get<IResumoTotalFeedbackResponse>(`${DASHBOARD_URL}/resumo-total`, filtro);

export {
  getMaisReceberamFeedback,
  getMaisForneceramFeedback,
  getResumoTotalFeedback,
};
